import { CatForDisplay } from '../../../../models';

/** when extending this class be sure to implement
 * @Input()
 * override categories: CatForDisplay[] = [];
 */
export abstract class NgxAimCategoryFilterClass {
  categories: CatForDisplay[] = [];
}
